import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { X } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const code = params.get("booking");
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <div className="w-16 h-16 rounded-full border border-[#0F172A] text-[#0F172A] flex items-center justify-center mx-auto">
        <X size={28}/>
      </div>
      <div className="overline mt-8">Payment cancelled</div>
      <h1 className="font-serif-display text-5xl mt-4">No worries.</h1>
      <p className="mt-6 text-[#4A4A4A]">Your booking {code && <>({code})</>} is still active. You can pay the deposit anytime from your tracking page.</p>
      <div className="mt-10 flex gap-3 justify-center">
        <Link to="/track" className="px-8 py-3 bg-[#0F172A] text-[#FFFFFF] text-xs uppercase tracking-[0.25em]">Back to Tracking</Link>
        <Link to="/" className="px-8 py-3 border border-[#0F172A] text-xs uppercase tracking-[0.25em]">Home</Link>
      </div>
    </div>
  );
}
